import Vue from 'vue';
import VueRouter from 'vue-router';
import { isEmpty } from 'lodash';
import store from '@/store';
import AlertDetails from '@/views/alerts/details/AlertDetails.vue';
import TaskBoard from '@/views/task/board/TaskBoard.vue';
import Login from '../views/login/Login.vue';
import Forgot from '../views/login/Forgot.vue';
import Recover from '../views/login/Recover.vue';
import DisableAlert from '../views/login/DisableAlerts.vue';
import Sended from '../views/login/Sended.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/forgot-password',
    name: 'Forgot',
    component: Forgot,
  },
  {
    path: '/recover-password/:token',
    name: 'Recover',
    component: Recover,
  },
  {
    path: '/disable-alert/:token',
    name: 'DisableAlert',
    component: DisableAlert,
  },
  {
    path: '/email-sended',
    name: 'Sended',
    component: Sended,
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: () => import('../views/alerts/Alerts.vue'),
  },
  {
    path: '/alert/:id/details',
    name: 'AlertDetails',
    component: AlertDetails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/tasks',
    name: 'TaskBoard',
    component: TaskBoard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/knowledge-base',
    name: 'KnowledgeBase',
    component: () => import('../views/knowledgeBase/KnowledgeBase.vue'),
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/reports/Reports.vue'),
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/settings/Settings.vue'),
  },
  {
    path: '/catalogs',
    name: 'Catalogs',
    component: () => import('../views/catalogs/Catalogs.vue'),
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/support/Support.vue'),
  },
  {
    path: '/holes',
    name: 'Holes',
    component: () => import('../views/holes/list/HoleList.vue'),
  },
  {
    path: '/course',
    name: 'Course',
    component: () => import('../views/course/course/CourseMap.vue'),
  },
  {
    path: '/sensors',
    name: 'Senors',
    component: () => import('../views/sensors/list/Sensors.vue'),
  },
  {
    path: '/weather-stations',
    name: 'Stations',
    component: () => import('../views/stations/list/Stations.vue'),
  },
  {
    path: '/spot-check-device',
    name: 'SpotCheckDevice',
    component: () => import('../views/spotCheckDevice/SpotCheckDevice.vue'),
  },
  {
    path: '/create-hole',
    name: 'CreateHole',
    component: () => import('../views/holes/HoleOperations.vue'),
  },
  {
    path: '/update-hole/:id',
    name: 'UpdateHole',
    component: () => import('../views/holes/HoleOperations.vue'),
  },
  {
    path: '/new-user',
    name: 'CreateUser',
    component: () => import('../views/users/UserOperations.vue'),
  },
  {
    path: '/update-user/:id',
    name: 'UpdateUser',
    component: () => import('../views/users/UserOperations.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/users/Users.vue'),
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('../views/course/courses/Courses.vue'),
  },
  {
    path: '/setup-course/:course_id?',
    name: 'SetUpCourse',
    component: () => import('../views/course/setup/SetupCourse.vue'),
  },
  {
    path: '/locator',
    name: 'Locator',
    component: () => import('../views/locator/Locator.vue'),
  },
  { path: '*', redirect: '/dashboard' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/login', '/recover-password', '/forgot-password', '/email-sended', '/disable-alert'];
  const path = `/${to.path.split('/')[1]}`;
  const authRequired = !publicPages.includes(path);
  const loggedIn = !isEmpty(store.state.user);

  if (path === '/disable-alert') {
    store.commit('setPrevRoute', from.path);
    return next();
  }

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if (!authRequired && loggedIn) {
    return next('/dashboard');
  }

  store.commit('setPrevRoute', from.path);
  return next();
});

export default router;
